import React, { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import './BookingSidebar.css';
import AirbnbLinkImage from '../assets/AirbnbLink.png';

const AIRBNB_LISTING_URL = 'https://www.airbnb.com/rooms/1553679519056205793?viralityEntryPoint=1&s=76';

function BookingSidebar({ isOpen, onClose }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <div className={`booking-sidebar ${isOpen ? 'booking-sidebar--open' : ''}`} aria-hidden={!isOpen}>
      <div
        className="booking-sidebar__backdrop"
        role="button"
        tabIndex={-1}
        onClick={onClose}
        aria-label="Close booking sidebar"
      ></div>
      <aside className="booking-sidebar__panel" role="dialog" aria-modal="true" aria-label="Book your stay">
        <button
          className="booking-sidebar__close"
          onClick={onClose}
          aria-label="Close booking sidebar"
          type="button"
        >
          <FaTimes />
        </button>
        <h2 className="booking-sidebar__title">Reserve Your Stay</h2>
        <p className="booking-sidebar__subtitle">Secure your dates directly through Airbnb.</p>
        <div className="booking-sidebar__embed">
          <a
            href={AIRBNB_LISTING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="booking-sidebar__link"
          >
            <img
              src={AirbnbLinkImage}
              alt="Book on Airbnb - Hacienda del Sol"
              className="booking-sidebar__image"
            />
          </a>
        </div>
      </aside>
    </div>
  );
}

export default BookingSidebar;


